/**
 * 
 * key
 * 
 */


const key = 'ZmFtaWx5X2RldGFpbHM='

export default key 